import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export const useGamePageState = () => {
    const { roomLoaded } = useSelector((state) => state.bingo);
    const { currentGameId } = useSelector((state) => state.casino.currentGame);

    useEffect(() => {
        const pageClass = 'embedded-game-loaded';

        if (roomLoaded || currentGameId !== null) {
            document.body.classList.add(pageClass);
        } else {
            document.body.classList.remove(pageClass);
        }

        return () => {
            document.body.classList.remove(pageClass);
        };
    }, [roomLoaded, currentGameId]);
};
